import { useCallback, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowNotification } from "../Common/showNotification";

function useUploadFakeImage() {
  const [fetchWrapper] = useFetch();
  const showNotification = useShowNotification();

  const [uploadedImageId, setUploadedImageId] = useState();
  const [uploadAbortController, setUploadAbortController] = useState(
    new AbortController()
  );

  const uploadFakeImage = (
    capturedImage,
    timeout_duration,
    callGetFakeImage
  ) => {
    let timeout_id = setTimeout(() => {
      //Abort summary, energy consumption distribution, and device list's fetch request
      uploadAbortController.abort("");
      //Assign a new abort controller
      setUploadAbortController(new AbortController());
    }, (timeout_duration * 1000) / 2);

    fetchWrapper({
      endpoint_url: "image/uploadFakeImage",
      abort_controller: uploadAbortController,
      params: {
        image_url: capturedImage,
        image_size: { width: 0, height: 0 },
      },
      onSuccess: (fetch_output) => {
        clearTimeout(timeout_id);
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          setUploadedImageId(data);
          callGetFakeImage(data);
        } else {
          showNotification({
            message: "Failed to upload image.",
            description: "Please make sure network connection is available",
          });
        }
      },
      onFetchError: () =>
        showNotification({
          message: "Failed to upload image.",
          description: "Please make sure network connection is available",
        }),

      onResponseError: () =>
        showNotification({
          message: "Failed to upload image.",
          description: "Please make sure network connection is available",
        }),
    });
  };

  return { uploadFakeImage, uploadedImageId, setUploadedImageId };
}

export default useUploadFakeImage;
